<div class="custom-page-column pdf-page app-cp-01-40-07-06" id="cp400706">
  <p class="font-small text-end">
    <b
      >COMMERCIAL PROPERTY<br />
      CP 01 40 07 06</b
    >
  </p>
  <p class="font-medium" style="text-align: center">
    <b>THIS ENDORSEMENT CHANGES THE POLICY. PLEASE READ IT CAREFULLY.</b>
  </p>
  <p class="font-large" style="text-align: center">
    <b>EXCLUSION OF LOSS DUE TO VIRUS OR BACTERIA</b>
  </p>

  <p class="font-small">
    This endorsement modifies insurance provided under the following:
  </p>
  <p class="font-small ps-10">
    COMMERCIAL PROPERTY COVERAGE PART<br />
    STANDARD PROPERTY POLICY
  </p>

  <table class="font-small">
    <tbody>
      <tr>
        <td style="width: 50%;vertical-align: top; ">
          <ol type="A">
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              The exclusion set forth in Paragraph <b>B.</b> applies to all
              coverage under all forms and endorsements that comprise this
              Coverage Part or Policy, including but not limited to forms or
              endorsements that cover property damage to buildings or personal
              property and forms or endorsements that cover business income,
              extra expense or action of civil authority.
            </span>
              </li>
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              We will not pay for loss or damage caused by or resulting from any
              virus, bacterium or other microorganism that induces or is capable
              of inducing physical distress, illness or disease.<br />
              However, this exclusion does not apply to loss or damage caused by
              or resulting from "fungus", wet rot or dry rot. Such loss or
              damage is addressed in a separate exclusion in this Coverage Part
              or Policy
            </span>
              </li>
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              With respect to any loss or damage subject to the exclusion in
              Paragraph <b>B.,</b> such exclusion supersedes any exclusion
              relating to "pollutants".
            </span>
              </li>
          </ol>
        </td>
        <td style="width: 50%; vertical-align: top;">
          <ol type="A" start="4">
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              The following provisions in this Coverage Part or Policy are
              hereby amended to remove reference to bacteria:
              <ol>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  Exclusion of "Fungus", Wet Rot, Dry Rot And Bacteria; and
                </span>
              </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  Additional Coverage – Limited Coverage for "Fungus", Wet Rot,
                  Dry Rot And Bacteria, including any endorsement increasing the
                  scope or amount of coverage.
                </span>
              </li>
              </ol>
            </span>
              </li>
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              The terms of the exclusion in Paragraph <b>B.,</b> or the
              inapplicability of this exclusion to a particular loss, do not
              serve to create coverage for any loss that would otherwise be
              excluded under this Coverage Part or Policy.
            </span>
              </li>
          </ol>
        </td>
      </tr>
    </tbody>
  </table>
</div>
